import React from 'react';
import styled, { keyframes, css } from 'styled-components';

const ringPulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 3px var(--ring-color), 0 0 16px 4px var(--ring-color); }
  50% { box-shadow: 0 0 0 5px var(--ring-color), 0 0 24px 8px var(--ring-color); }
`;

const AvatarWrapper = styled.div<{ size: number; ringColor?: string; isActive?: boolean }>`
  --ring-color: ${({ ringColor }) => ringColor || 'rgba(255,255,255,0.5)'};
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid var(--ring-color);
  flex-shrink: 0;
  box-shadow: 0 0 0 3px var(--ring-color);
  background: rgba(255,255,255,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ isActive }) =>
    isActive &&
    css`
      animation: ${ringPulse} 2s ease-in-out infinite;
    `}
`;

const AvatarImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const FallbackText = styled.span<{ size: number }>`
  font-size: ${({ size }) => Math.round(size * 0.4)}px;
  font-weight: bold;
  color: var(--color-white);
  text-transform: uppercase;
  user-select: none;
`;

interface Props {
  pfpUrl?: string;
  name?: string;
  size?: number;
  ringColor?: string;
  isActive?: boolean;
  className?: string;
}

const PlayerAvatar: React.FC<Props> = ({
  pfpUrl,
  name = '?',
  size = 48,
  ringColor,
  isActive = false,
  className,
}) => {
  const initial = name.trim().charAt(0) || '?';

  return (
    <AvatarWrapper size={size} ringColor={ringColor} isActive={isActive} className={className}>
      {pfpUrl ? (
        <AvatarImg
          src={pfpUrl}
          alt={name}
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).style.display = 'none';
          }}
        />
      ) : (
        <FallbackText size={size}>{initial}</FallbackText>
      )}
    </AvatarWrapper>
  );
};

export default PlayerAvatar;
